import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PreviewNumberModalComponent } from 'src/app/pages/client-lead/preview-number-modal/preview-number-modal.component';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { ServerService } from 'src/app/services/server.service';

@Component({
  selector: 'app-caller-id-verify-component',
  templateUrl: './caller-id-verify-component.component.html',
  styleUrls: ['./caller-id-verify-component.component.scss']
})
export class CallerIdVerifyComponentComponent implements OnInit {

  verificationData: any;
  callIdPhone: any;

  constructor(private fb: FormBuilder, public clipBoardService: ClipBoardService,
    private snackBar: MatSnackBar,
    private serverService: ServerService,
    private dialogRef: MatDialogRef<PreviewNumberModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
    if (localStorage.getItem('caller-id-number')) {
      this.callIdPhone = localStorage.getItem('caller-id-number')
    }
  }

  ngOnInit(): void {
    //console.log(this.data)
    this.verificationData = this.data
  }

  confirm() {
    //window.open('https://api.whatsapp.com/send?phone=' + JSON.stringify(this.form.value.contactNumber).replace('+', ''))
  }

  close() {
    this.dialogRef.close();
  }

}
